/* eslint-disable */

export const accuracySentVolumeSell = {
    GET_ACCURACY_SENT_VOLUME_SELL_REQUEST: 'GET_ACCURACY_SENT_VOLUME_SELL_REQUEST',
    GET_ACCURACY_SENT_VOLUME_SELL_SUCCESS: 'GET_ACCURACY_SENT_VOLUME_SELL_SUCCESS',
    GET_ACCURACY_SENT_VOLUME_SELL_FAILURE: 'GET_ACCURACY_SENT_VOLUME_SELL_FAILURE',
};
